export const getSignupUrl = () => `/signup?start`;
